import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

export const Pricing = () => {
  const [plans, setPlans] = useState([]);
  const [toolkitPlans, setToolkitPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showToolkitModal, setShowToolkitModal] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const fetchPlans = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          "https://admin.businessunbuzzed.com/api/get_plans"
        );
        const result = await res.json();
        if (isMounted) {
          const allPlans = result?.plans ?? [];
          setPlans(allPlans.filter(p => p.type !== "toolkit"));
          setToolkitPlans(allPlans.filter(p => p.type === "toolkit"));
        }
      } catch (err) {
        console.error("Error fetching plans:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    fetchPlans();
    return () => { isMounted = false; };
  }, []);

 const handlePlanSelect = (plan) => {
  const token = localStorage.getItem("token");
  if (!token) {
    Swal.fire({
      title: "⚠️ Sign In Required",
      text: "Please login to select a plan.",
      icon: "warning",
      confirmButtonText: "Go to Login",
      confirmButtonColor: "rgb(204, 102, 0)",
    }).then((result) => {
      if (result.isConfirmed) {
        setTimeout(() => {
          window.location.href = "/login";
        }, 150);
      }
    });
    return;
  }

  if (plan.type === "toolkit") {
    setShowToolkitModal(true);
    return;
  }

  const url = `https://admin.businessunbuzzed.com/plans/checkout/${plan.id}&token=${token}`;
  setTimeout(() => {
    window.location.href = url;
  }, 150);
};

const handleToolkitSelect = (toolkitPlanId) => {
  const token = localStorage.getItem("token");
  if (!token) return;
  const url = `https://admin.businessunbuzzed.com/plans/checkout/${toolkitPlanId}&token=${token}`;
  setTimeout(() => {
    window.location.href = url;
  }, 150);
};


  return (
    <section id="pricing" className="pricing-section">
      <div className="container text-center">
        <div className="section-title">
          <h2>Our Plans</h2>
          <p>Select the plan that fits you best</p>
        </div>

        <div
          className="row"
          style={{
            display: "flex",
            gap: "20px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {loading ? (
            <div className="spinner"></div>
          ) : (
            <>
              {plans.map((plan, i) => (
                <div
                  key={i}
                  className={`col-md-4 pricing-card ${
                    plan.highlight ? "highlight" : ""
                  }`}
                  style={{ flex: "1 1 300px" }}
                >
                  <div
                    className="card shadow-lg card-res"
                    style={{
                      padding: "30px",
                      borderRadius: "15px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <h3>{plan.name}</h3>
                    <h4 className="price"> ${plan.price}</h4>
                    <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
                      {plan.features?.map((f, j) => (
                        <li key={j}>{f}</li>
                      )) ?? <li>No features listed</li>}
                    </ul>
                    <button
                      className="btn btn-custom"
                      style={{
                        marginTop: "15px",
                        padding: "12px 25px",
                        borderRadius: "10px",
                        backgroundColor: "#CC6600",
                        color: "#fff",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onClick={() => handlePlanSelect(plan)}
                    >
                      {plan.cta || "Select Plan"}
                    </button>
                  </div>
                </div>
              ))}

              {toolkitPlans.length > 0 && (
                <div
                  className="col-md-4 pricing-card"
                  style={{ flex: "1 1 300px" }}
                >
                  <div
                    className="card shadow-lg card-res"
                    style={{
                      padding: "30px",
                      borderRadius: "15px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <h3>Governance Toolkits</h3>
                    <h4 className="price">
                      ${Math.min(...toolkitPlans.map(p => parseFloat(p.price)))}-
                      ${Math.max(...toolkitPlans.map(p => parseFloat(p.price)))}
                    </h4>
                    <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
                      {toolkitPlans.map((tk) => (
                        <li key={tk.id}>
                          {tk.name}: ${tk.price}
                        </li>
                      ))}
                    </ul>
                    <button
                      className="btn btn-custom"
                      style={{
                        marginTop: "15px",
                        padding: "12px 25px",
                        borderRadius: "10px",
                        backgroundColor: "#CC6600",
                        color: "#fff",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onClick={() => setShowToolkitModal(true)}
                    >
                      Get Toolkit
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {showToolkitModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowToolkitModal(false)}
        >
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <h2>CHOOSE YOUR TOOLKIT PLAN</h2>
            <div className="modal-buttons">
              {loading ? (
                <div className="spinner"></div>
              ) : toolkitPlans.length > 0 ? (
                toolkitPlans.map((tk) => (
                  <button
                    key={tk.id}
                    onClick={() => handleToolkitSelect(tk.id)}
                  >
                    {tk.name} – ${tk.price}
                  </button>
                ))
              ) : (
                <p>No Toolkit Plans Available</p>
              )}
            </div>
            <button
              className="modal-cancel"
              onClick={() => setShowToolkitModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Pricing;
